import { render, staticRenderFns } from "./SplitSet.vue?vue&type=template&id=473d7fb6&scoped=true"
import script from "./SplitSet.vue?vue&type=script&lang=js"
export * from "./SplitSet.vue?vue&type=script&lang=js"
import style0 from "./SplitSet.vue?vue&type=style&index=0&id=473d7fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d7fb6",
  null
  
)

export default component.exports